module.exports = __webpack_public_path__ + "static/media/logo-gpx-exchange.ac45dade.png";